import React from "react";
import RepeatIcon from "../SVG/RepeatIcon";

type Button360Props = {
  onClickFn?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
};

const Button360: React.FC<Button360Props> = ({ onClickFn, disabled }) => {
  return (
    <button
      className={`group rounded px-20px py-3 shadow-btnShadow hover:outline hover:outline-legacy-primary`}
      onClick={onClickFn}
      disabled={disabled}
    >
      <div className="flex items-center justify-center gap-4">
        <RepeatIcon />
        <div className="text-legacy-primary">360°</div>
      </div>
    </button>
  );
};

export default Button360;
